<template>
  <ul class="chat-content-container" ref="chatPanelRef">
    <template v-if="messages.length > 0">
      <ChatMessage
        v-for="message in messages"
        :key="message.msg_id"
        :text="message.content.msg_body.text"
        :image="message.content.msg_body.media_id"
        :other-avatar="avatar ? avatar : defaultAvatar"
        :other-send="message.content.from_id !== phone"
        :type="message.content.msg_type"
        @update-content-height="scrollBottom"
      />
    </template>
  </ul>
</template>
<script>
import ChatMessage from "@/views/message/components/ChatPanel/ChatMessage";
import defaultAvatar from "@/assets/personal/default_avatar@2x.png";
import { mapState, mapActions } from "vuex";

export default {
  name: "ChatPanel",
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultAvatar,
      avatar: ""
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    messages() {
      this.$nextTick(this.scrollBottom);
    }
  },
  mounted() {
    this.scrollBottom();
  },
  computed: {
    ...mapState("user", ["phone"])
  },
  components: { ChatMessage },
  methods: {
    ...mapActions("chat", ["getUserInfo", "getResource"]),
    async fetchData() {
      const { user_info } = await this.getUserInfo(this.$route.params.id);
      if (user_info.avatar) {
        const { url } = await this.getResource(user_info.avatar);
        this.avatar = url;
      } else {
        this.avatar = user_info.avatar;
      }
    },
    scrollBottom() {
      this.$refs["chatPanelRef"].scrollTop = this.$refs[
        "chatPanelRef"
      ].scrollHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-content-container {
  padding: 20px 15px;
  flex: 1;
  overflow: scroll;
  width: 100%;
  background: #f8f8f8;
}
</style>
